import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [LanguagesComponent],
  imports: [MatButtonModule, MatIconModule, OverlayPanelModule, CommonModule],
  exports: [LanguagesComponent],
})
export class LanguagesModule {}
